export default __webpack_public_path__ + "static/media/2D.13a4e33a.svg";